import React from "react";

import Sidebar from "./Sidebar";
import styled from "styled-components";
import { Outlet } from "react-router-dom";
import SidebarProvider from "../context/SidebarContext";

const Layout = () => {
  return (
    <SidebarProvider>
      <div className="d-flex">
        <Sidebar />
        <StyleWrapper className="d-flex flex-column">
          <Outlet />
        </StyleWrapper>
      </div>
    </SidebarProvider>
  );
};

export default Layout;

const StyleWrapper = styled.div`
  flex-grow: 1;
  padding: 20px 10px;

  & > main {
    flex-grow: 1;
    margin-top: 15px;
    padding: 14px 20px;
  }
`;
